export default "__VITE_ASSET__Dszj1mQU__"